import React, { lazy } from 'react';

const CreateTemplate = lazy(() => import('../pages/template/create'));
const DetailTemplate = lazy(() => import('../pages/template/detail'));
const CreateCard = lazy(() => import('../pages/card/create'));
const CreateCompanyCard = lazy(() => import('../pages/company-card/create'));
const DetailCard = lazy(() => import('../pages/card/detail'));
const DetailCompanyCard = lazy(() => import('../pages/company-card/detail'));
const CardPage = lazy(() => import('../pages/card'));
const CompanyCardPage = lazy(() => import('../pages/company-card'));
const CustomCardPage = lazy(() => import('../pages/custom-card'));
const CustomCardDetail = lazy(() => import('../pages/custom-card/detail'));
const Template = lazy(() => import('../pages/template'));
const Setting = lazy(() => import('../pages/setting'));
const ThemePage = lazy(() => import('../pages/theme'));
const DetailTheme = lazy(() => import('../pages/theme/detail'));
const CreateTheme = lazy(() => import('../pages/theme/create'));
const DesignerPage = lazy(() => import('../pages/designer'));
const DesignerDetail = lazy(() => import('../pages/designer/detail'));
const UserPage = lazy(() => import('../pages/user'));
const UserDetail = lazy(() => import('../pages/user/detail'));
const AnnouncementPage = lazy(() => import('../pages/announcement'));
const AnnouncementDetail = lazy(() => import('../pages/announcement/detail'));
const CreateAnnouncement = lazy(() => import('../pages/announcement/create'));
const CompanyPage = lazy(() => import('../pages/company'));
const CompanyDetailPage = lazy(() => import('../pages/company/detail'));

interface Route {
  key: string
  path: string
  component: React.LazyExoticComponent<() => JSX.Element>
  private?: boolean
  exact: boolean
  children?: Route[]
}

const routes: Route[] = [
  {
    key: 'customcard',
    path: '/customcard',
    component: CustomCardPage,
    private: true,
    exact: true,
    children: [{
      key: 'customcard-detail',
      path: '/:id',
      component: CustomCardDetail,
      exact: true,
    }],
  },
  {
    key: 'card',
    path: '/card',
    component: CardPage,
    private: true,
    exact: true,
    children: [
      {
        key: 'create-card',
        path: '/create',
        component: CreateCard,
        exact: true,
      },
      {
        key: 'edit-card',
        path: '/:id',
        component: DetailCard,
        exact: true,
      },
    ],
  },
  {
    key: 'company-card',
    path: '/company-card',
    component: CompanyCardPage,
    private: true,
    exact: true,
    children: [
      {
        key: 'create-company-card',
        path: '/create',
        component: CreateCompanyCard,
        exact: true,
      },
      {
        key: 'edit-company-card',
        path: '/:id',
        component: DetailCompanyCard,
        exact: true,
      },
    ],
  },
  {
    key: 'template',
    path: '/template',
    component: Template,
    private: true,
    exact: true,
    children: [
      {
        key: 'create-template',
        path: '/create',
        component: CreateTemplate,
        exact: true,
      },
      {
        key: 'edit-template',
        path: '/:id',
        component: DetailTemplate,
        exact: true,
      },
    ],
  },
  {
    key: 'setting',
    path: '/setting',
    component: Setting,
    private: true,
    exact: true,
  },
  {
    key: 'theme',
    path: '/theme',
    component: ThemePage,
    private: true,
    exact: true,
    children: [
      {
        key: 'create-theme',
        path: '/create',
        component: CreateTheme,
        exact: true,
      },
      {
        key: 'edit-theme',
        path: '/:id',
        component: DetailTheme,
        exact: true,
      },
    ],
  },
  {
    key: 'designer',
    path: '/designer',
    component: DesignerPage,
    private: true,
    exact: true,
    children: [
      {
        key: 'edit-designer',
        path: '/:id',
        component: DesignerDetail,
        exact: true,
      },
    ],
  },
  {
    key: 'user',
    path: '/user',
    component: UserPage,
    private: true,
    exact: true,
    children: [
      {
        key: 'edit-user',
        path: '/:id',
        component: UserDetail,
        exact: true,
      },
    ],
  },
  {
    key: 'announcement',
    path: '/announcement',
    component: AnnouncementPage,
    private: true,
    exact: true,
    children: [
      {
        key: 'create-announcement',
        path: '/create',
        component: CreateAnnouncement,
        exact: true,
      },
      {
        key: 'edit-announcement',
        path: '/:id',
        component: AnnouncementDetail,
        exact: true,
      },
    ],
  },
  {
    key: 'company',
    path: '/company',
    component: CompanyPage,
    private: true,
    exact: true,
    children: [
      {
        key: 'edit-company',
        path: '/:id',
        component: CompanyDetailPage,
        exact: true,
      },
    ],
  },
];

export default routes;
